import React, { Component } from 'react';

import './styles.css';

class LoadingIndicator extends Component {
  render() {
    return (
      <div className="LoadingIndicator" />
    );
  }
}

export default LoadingIndicator;
